import { normalizeLang, type Lang } from "../i18n/i18n";

/** Rechtstexte der Plattform; Schlüssel = Seite der mQorva-Website, Route `/legal/:page` und Endpunkt `LEGAL_DOCUMENT_PATH`. */
export const LEGAL_DOCUMENT_PAGES = ["agb", "datenschutz", "impressum"] as const;
export type LegalDocumentPageKey = (typeof LEGAL_DOCUMENT_PAGES)[number];

export function isLegalDocumentPage(value: string | undefined): value is LegalDocumentPageKey {
  return LEGAL_DOCUMENT_PAGES.some((page) => page === value);
}

/** Pfad des gemeinsamen Endpunkts (`shared/backend/Legal/PlatformLegalDocuments.cs`). */
export function legalDocumentPath(page: LegalDocumentPageKey, lang: string): string {
  return `/api/v1/legal/${page}?lang=${encodeURIComponent(lang)}`;
}

export type LegalTexts = {
  legal: string; agb: string; datenschutz: string; impressum: string;
  plan: string; changePlan: string; choosePlan: string; loadError: string; loading: string;
};

/** Texte der Rechtsseite und des Navigations-Fußbereichs in allen Shared-Sprachen. */
export const legalDocumentTranslations = {
  de: { legal: "Rechtliches", agb: "AGB", datenschutz: "Datenschutz", impressum: "Impressum", plan: "Tarif", changePlan: "Tarif wechseln", choosePlan: "Tarif wählen", loadError: "Das Dokument konnte nicht geladen werden.", loading: "Lädt…" },
  en: { legal: "Legal", agb: "Terms", datenschutz: "Privacy", impressum: "Imprint", plan: "Plan", changePlan: "Change plan", choosePlan: "Choose plan", loadError: "The document could not be loaded.", loading: "Loading…" },
  ru: { legal: "Правовая информация", agb: "Условия", datenschutz: "Конфиденциальность", impressum: "Выходные данные", plan: "Тариф", changePlan: "Сменить тариф", choosePlan: "Выбрать тариф", loadError: "Не удалось загрузить документ.", loading: "Загрузка…" },
  uk: { legal: "Правова інформація", agb: "Умови", datenschutz: "Конфіденційність", impressum: "Вихідні дані", plan: "Тариф", changePlan: "Змінити тариф", choosePlan: "Вибрати тариф", loadError: "Не вдалося завантажити документ.", loading: "Завантаження…" },
  it: { legal: "Note legali", agb: "Condizioni", datenschutz: "Privacy", impressum: "Colophon", plan: "Piano", changePlan: "Cambia piano", choosePlan: "Scegli piano", loadError: "Impossibile caricare il documento.", loading: "Caricamento…" },
} satisfies Record<Lang, LegalTexts>;

export function legalTexts(locale: string): LegalTexts {
  return legalDocumentTranslations[normalizeLang(locale) ?? "de"];
}
